import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Modal, Button } from 'react-bootstrap';

const ComplaintSourcesChartsModal = ({ show, handleClose }) => {
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
  const [sourcesData, setSourcesData] = useState(null);
  const [loading, setLoading] = useState(true);

  const complaintSources = [
    "Helpline",
    "Chatbot",
    "Whatsapp",
    "Social Media",
    "By Post",
    "By Hand",
    "By Email",
    "Public Form",
    "Other"
  ];
 
  const sourceColors = {
    "Helpline": "#487fff",    // Blue
    "Chatbot": "#22d3ee",     // Emerald
    "Whatsapp": "#16a34a",    // Cyan
    "Social Media": "#2563eb", // Purple
    "By Post": "#ff9f29",      // Amber
    "By Hand": "#fbbf24",      // Yellow
    "By Email": "#f472b6",     // Pink
    "Public Form": "#dc2626",  // Red
    "Other": "#4b5563"        // Gray
  };

  const baseChartOptions = {
    chart: {
      type: 'area',
      toolbar: {
        show: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth'
    },
    xaxis: {
      type: 'category',
      labels: {
        rotate: -45,
        style: {
          fontSize: '12px'
        }
      }
    },
    tooltip: {
      x: {
        format: 'MMM yyyy'
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${API_BASE_URL}/backend/complaints/get-complaints-count-month-source`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        });

        if (response.ok) {
          const result = await response.json();
          if (result.status) {
            setSourcesData(result.data);
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (show) {
      fetchData();
    }
  }, [show, API_BASE_URL]);

  const renderChartForSource = (source) => {
    if (!sourcesData || !sourcesData[source]) return null;
  
    const sourceData = sourcesData[source];
    const categories = sourceData.map(item => item.month_year);
    const seriesData = sourceData.map(item => item.count);
  
    return (
      <div key={source} className="mb-4 p-3 border rounded">
        <h6 className="text-center mb-3">{source}</h6>
        <ReactApexChart
          options={{
            ...baseChartOptions,
            xaxis: {
              ...baseChartOptions.xaxis,
              categories
            },
            colors: [sourceColors[source] || '#64748b'], // Default to gray if source not found
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.3,
                stops: [0, 100]
              }
            }
          }}
          series={[{
            name: 'Complaints',
            data: seriesData
          }]}
          type="area"
          height={250}
        />
      </div>
    );
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered scrollable>
      <Modal.Header closeButton className="bg-light">
        <img 
          src={process.env.PUBLIC_URL + "/assets/images/logo_fw.png"}
          alt="Logo" 
          className="mx-20 my-4" 
          style={{ width: '90px', height: 'auto' }} 
        />
        <Modal.Title className="h5">Complaints Statistics by Source</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="row">
            {complaintSources.map(source => (
              <div key={source} className="col-md-6">
                {renderChartForSource(source)}
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="bg-light">
        <Button variant="secondary" size="sm" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ComplaintSourcesChartsModal;